export function cookie() {
    window.cookieconsent_options = {
        "message": "We use cookies on this website to help give you the best experience when you visit and to measure traffic to our site. By continuing on this website, you consent to the use of cookies on your device. To learn more, please visit our <a style=\"color: #ffffff; text-decoration: underline;\" href=\"/privacy-policy/\">Privacy Statement</a>.",
        "dismiss": "Continue",
        "learnMore": "More info",
        "link": null,
        "theme": "light-bottom"
    };
}